@for (client of clients() | sort: 'name'; track client.id) {
  <button
    mat-menu-item
    class="clientPicker_item"
    [ngClass]="{
      'selectedClient': client.id === selectedClientId()
    }"
    (click)="client.id !== selectedClientId() && onClientChange(client)"
  >
    <div class="d-flex w-100 align-items-center text-truncate">
      <div class="text-truncate">
        <div class="text-truncate" [title]="client.name">
          {{ client.name }}
        </div>

        @if (client.id === selectedClientId()) {
          <div class="text-small text-muted">Active session</div>
        }
      </div>

      @if (client.logoUrl) {
        <img
          class="clientPicker_logo ms-auto ps-1"
          [src]="client.logoUrl"
          [alt]="client.name"
        />
      } @else {
        <span class="ms-auto">&nbsp;</span>
      }
    </div>
  </button>
}
